import React, { useState, useEffect } from 'react';
import './CommunityEventInvite.css';
import API_URL from '../apiUrl';

const CommunityEventInvite = () => {
  const [formData, setFormData] = useState({ name: '', email: '', guests: 1 });
  const [status, setStatus] = useState({ loading: false, success: '', error: '' });
  const [open, setOpen] = useState(false);

  const MIN_GUESTS = 1;
  const MAX_GUESTS = 20;
  const setGuests = (n) =>
    setFormData((prev) => ({
      ...prev,
      guests: Math.max(MIN_GUESTS, Math.min(MAX_GUESTS, n))
    }));

  useEffect(() => {
    const onKey = (e) => {
      if (e.key === 'Escape') setOpen(false);
    };
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const submitRsvp = async (e, attending) => {
    e.preventDefault();
    if (!formData.name.trim()) {
      setStatus({ loading: false, success: '', error: 'Please enter your name.' });
      return;
    }

    setStatus({ loading: true, success: '', error: '' });

    try {
      const response = await fetch(`${API_URL}/api/community-invite-rsvp/`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          name: formData.name,
          email: formData.email,
          guests: formData.guests,
          attending
        })
      });
      const result = await response.json();
      if (response.ok && result.success) {
        setStatus({ loading: false, success: result.message || 'Thanks! Your RSVP has been received.', error: '' });
        setFormData({ name: '', email: '', guests: 1 });
      } else {
        setStatus({ loading: false, success: '', error: result.message || 'Could not submit RSVP.' });
      }
    } catch (err) {
      setStatus({ loading: false, success: '', error: 'Network error. Please try again.' });
    }
  };

  const flyerUrl = `${process.env.PUBLIC_URL || ''}/flyer.jpg`;

  return (
    <div
      className="cei-page"
      style={{ backgroundImage: `url("${flyerUrl}")` }}
    >
      <button
        type="button"
        className="cei-rsvp-cta"
        onClick={() => setOpen(true)}
        data-testid="open-rsvp"
      >
        RSVP NOW
      </button>

      {open && (
        <div
          className="cei-modal-backdrop"
          onClick={() => setOpen(false)}
          data-testid="rsvp-modal"
          role="dialog"
          aria-modal="true"
          aria-labelledby="cei-rsvp-title"
        >
          <div className="cei-modal" onClick={(e) => e.stopPropagation()}>
            <button
              type="button"
              className="cei-modal-close"
              onClick={() => setOpen(false)}
              aria-label="Close RSVP form"
            >
              ×
            </button>
            <h2 className="cei-rsvp-title" id="cei-rsvp-title">RSVP</h2>
            <p className="cei-rsvp-sub">Reserve your spot for the July 18th community event.</p>
            <form className="cei-rsvp-form" onSubmit={(e) => submitRsvp(e, 'yes')}>
              <label className="cei-field">
                <span>Name</span>
                <input
                  type="text"
                  name="name"
                  value={formData.name}
                  onChange={handleChange}
                  placeholder="Full name"
                  autoComplete="name"
                  required
                />
              </label>
              <label className="cei-field">
                <span>Email <span className="cei-optional">(optional)</span></span>
                <input
                  type="email"
                  name="email"
                  value={formData.email}
                  onChange={handleChange}
                  placeholder="you@email.com"
                  autoComplete="email"
                />
              </label>

              <div className="cei-field cei-field-row">
                <span>Number of Guests</span>
                <div className="cei-counter" role="group" aria-label="Number of guests">
                  <button
                    type="button"
                    className="cei-counter-btn"
                    onClick={() => setGuests(formData.guests - 1)}
                    disabled={formData.guests <= MIN_GUESTS}
                    aria-label="Decrease guests"
                    data-testid="guests-decrement"
                  >
                    −
                  </button>
                  <input
                    type="number"
                    name="guests"
                    className="cei-counter-value"
                    min={MIN_GUESTS}
                    max={MAX_GUESTS}
                    value={formData.guests}
                    onChange={(e) => {
                      const n = parseInt(e.target.value, 10);
                      setGuests(Number.isFinite(n) ? n : MIN_GUESTS);
                    }}
                    aria-label="Number of guests"
                    data-testid="guests-value"
                  />
                  <button
                    type="button"
                    className="cei-counter-btn"
                    onClick={() => setGuests(formData.guests + 1)}
                    disabled={formData.guests >= MAX_GUESTS}
                    aria-label="Increase guests"
                    data-testid="guests-increment"
                  >
                    +
                  </button>
                </div>
              </div>

              {status.error && <div className="cei-msg cei-msg-error">{status.error}</div>}
              {status.success && <div className="cei-msg cei-msg-success">{status.success}</div>}

              <div className="cei-btn-row">
                <button
                  type="button"
                  className="cei-btn cei-btn-no"
                  onClick={(e) => submitRsvp(e, 'no')}
                  disabled={status.loading}
                  data-testid="rsvp-no"
                >
                  Can't make it
                </button>
                <button
                  type="submit"
                  className="cei-btn cei-btn-yes"
                  disabled={status.loading}
                  data-testid="rsvp-yes"
                >
                  {status.loading ? 'Sending…' : "I'll be there"}
                </button>
              </div>
            </form>
          </div>
        </div>
      )}
    </div>
  );
};

export default CommunityEventInvite;
